/**
 * Users
 */

// React
import React, {FunctionComponent, useContext, useEffect, useState} from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  getVariantInventoryItemsAction,
} from './actions';
import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectVariantInventoryItemsList,
  makeSelectVariantInventoryItemsCount,
} from './selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/variantInventoryList';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  DialogTitle, FormControl, Select, MenuItem,
} from '@material-ui/core';

// Icon

// Helper
import {removeEmptyValueObject} from '../../utils/helpers';

// Type
import {Props, VariantInventoryProps} from './interfaces';
import {Filter} from '../../utils/listDaynamicFilter';
import {useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& #showFilter .MuiInput-underline::before, & #showFilter .MuiInput-underline::after": {
        borderBottom: '2px solid #DFA01F !important',
      }
    },
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    showCount: {
      "& .MuiSelect-icon": {
        color: "#DFA01F",
      },
    },
  })
);
// Const
interface ObjectString {
  edit: string;
  detail: string;
  assign: string;
  inventory: string;
}
const translate: ObjectString = {
  edit: 'ویرایش',
  detail: 'جزیيات محصول',
  assign: 'لیست محصول',
  inventory: 'گزارش موجودی محصول',
};

type Inputs = {
  'customerNationalCode.contains': string;
};

const Products: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const {register, handleSubmit, reset} = useForm<Inputs>();
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [filters, setFilters] = useState([] as Filter[]);
  const urlParams = useParams();
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);

  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [description, setDescription] = useState("");

  const [openFilterBox, setOpenFilterBox] = React.useState(false);

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    reset({});
    setOpenFilterBox(false);
  };

  useEffect(() => {
    getVariantInventoryItems();
  }, [filtersValues]);

  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const getVariantInventoryItems = () => {
    const {page, size} = filtersValues;
    const variantId = urlParams.variantId;
    const warehouseId = urlParams.warehouseId;
    props.variantInventoryItemsDispatch({
      ...removeEmptyValueObject(filtersValues),
      skuId: { equals: variantId },
      warehouseId: { equals: warehouseId },
      status: { equals: 'LOCATED' },
      page,
      size,
    });
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleDisableUser = async () => {
    const body = props.productVariantInventoryItemsList.find(item => item.id === id) as any;
    await props.updateProductsDispatch({
      body: {...body, status: 'SUSPENDED'},
      pagination: filtersValues,
      id: props.match.params.partnerId,
    });
    setOpenConfirmDisable(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpen = (desc: string, type: string) => {
    setType(type);
    setOpenDialog(true);
    setDescription(desc);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setopenAdd(false);
  };

  const handleOpenConfirmUpdateState = (data: {id: number; body: any}) => {
    setId(data.id);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5} alignItems='center'>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" component="h2" className={classes.title}>
            {`لیست آیتم انبار های کالای`} {urlParams.name} - {'تنوع'} {urlParams.variantId}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}></Grid>
        <Grid container item spacing={6}>
          <Grid item xs={12}>
            {props.loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              props.productVariantInventoryItemsList && (
                <List
                  data={props.productVariantInventoryItemsList}
                  handleOpenConfirmDisable={handleOpenConfirmDisable}
                  handleOpen={handleOpen}
                  changeStatus={handleOpenConfirmUpdateState}
                />
              )
            )}
          </Grid>
          <Grid id="showFilter" item xs={12} sm={6}>
            {props.productVariantInventoryItemsList && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleCloseSelect}
                  className={classes.showCount}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            {props.productVariantInventoryItemsList && (
              <Pagination
                count={Math.ceil(props.productVariantInventoryItemsListCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>توضیحات</div>
        </DialogTitle>
        <DialogContent style={{minWidth: '500px'}}>
          {type === 'description' && (
            <p>{description}</p>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, VariantInventoryProps>({
  productVariantInventoryItemsList: makeSelectVariantInventoryItemsList(),
  productVariantInventoryItemsListCount: makeSelectVariantInventoryItemsCount(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    variantInventoryItemsDispatch: (payload: Object) => dispatch(getVariantInventoryItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Products);
